var map = {
	"./agro-logo-coloured.png": 1397,
	"./agro-logo-white.png": 1398,
	"./brf-logo-white.png": 1399,
	"./brf-minimal-logo-coloured.png": 1400,
	"./brfcomplete-logo-coloured.png": 575,
	"./next-logo-coloured.png": 1401,
	"./next-logo-coloured@2x.png": 1402,
	"./next-logo-coloured@3x.png": 1403
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1396;